var exports = {
  "iE": "wrapper__OsSk1Y",
  "wW": "wrapperCanExpand__SEVqPM",
  "x6": "button__jUz1rL",
  "Vl": "MergeBoxSectionHeading__tjMMZz",
  "MT": "contentLayout__RWjzcl",
  "WD": "wrapperLayout__1MCZo3",
};

module.exports = exports;
